import api from '@cannect/services/api'
import {
  TNpsFirstAnswerPayload,
  TNpsFirstAnswerResponse,
  TNpsInvitation,
  TNpsSubmitPayload,
  TNpsSubmitResponse
} from './types'

export const getNpsForm = async (token: string): Promise<TNpsInvitation> => {
  const { data } = await api.get<TNpsInvitation>(`/nps/${token}`)
  return data
}

export const sendNpsFirstAnswer = async (
  token: string,
  payload: TNpsFirstAnswerPayload
): Promise<TNpsFirstAnswerResponse> => {
  const { data } = await api.post<TNpsFirstAnswerResponse>(`/nps/${token}/first-answer`, payload)
  return data
}

export const submitNpsForm = async (token: string, payload: TNpsSubmitPayload): Promise<TNpsSubmitResponse> => {
  const { data } = await api.post<TNpsSubmitResponse>(`/nps/${token}/submit`, payload)
  return data
}
